import React from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { searchPopUpUpdate } from "../../store/actions/globalSearch";
import { isGlobalSearchModelVisible } from "../../store/actions/globalSearch";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";

function SearchResultCard(props) {
  const { titleIcon, titleText, totalResult, viewMoreLink, results, popUpClose } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isGlobalSearchVisible = useSelector((state) => state.globalSearch.isGlobalSearchVisible);
  const lists = results.slice(0, 10);
  return (
    <div className="card search-result" style={{ backgroundColor: '#fff', border: 'none', padding: '20px' }}>
      <div
        className="card-header d-flex justify-content-between"
        style={{
          backgroundColor: '#fff',
          borderBottom: '2px solid #333',
          padding: '10px 0px' // Add padding for alignment of header line
        }}
      >
        <div className="d-flex justify-content-start search-result-header">
          <img src={titleIcon} alt="Deviceicon" />
          <span className="table_column_header font-face-vz-eDS">{titleText}</span>
        </div>
        <div className="search-result-header-right">
          {totalResult > 0 && (
            <span className="model-sub-heading-search" style={{ paddingBottom: '2px', color: '#6F7171' }}>
              (Showing 1 - {totalResult <= 10 ? totalResult : "10"} of {totalResult})
            </span>
          )}
          <Link
            onClick={(e) => {
              e.preventDefault();
              dispatch(isGlobalSearchModelVisible(false));
              navigate(viewMoreLink.url, {
                state: viewMoreLink.isState && totalResult > 0 ? viewMoreLink.state : null,
              });
            }}
            className="search-link"
            style={{
              textDecoration: 'none',
              fontWeight: 400,
              fontSize: '12px',
              color: 'black',
              lineHeight: '16px',
            }}
          >
            view more
          </Link>
        </div>
      </div>

      {results.length < 1 && (
        <div className="search-result-not-found">
          No {titleText} found that match the filter criteria.
        </div>
      )}

      {results.length > 0 && (
        <ul className="list-group list-group-flush overflow-scroll search-result-area">
          {lists.map((result) => (
            <li
              key={result.id}
              className="list-group-item d-flex justify-content-between align-items-center"
              style={{ borderBottom: '1px solid #ccc', padding: '10px 0' }}
            >
              <div className="d-flex flex-column search-result-item">
                {!result.isState && (
                  <Link
                    className="custom-link"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(isGlobalSearchModelVisible(false));
                      dispatch(searchPopUpUpdate(false));
                      navigate(result.url);
                    }}
                    to={result.url}
                    style={{ textDecoration: 'none' }}
                  >
                    <p className="model-sub-heading-search font-face-vz-eTX">{result.title}</p>
                  </Link>
                )}
                {result.isState && (
                  <Link
                    className="custom-link"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(isGlobalSearchModelVisible(false));
                      dispatch(searchPopUpUpdate(true));
                      navigate(result.url.value, {
                        state: result.url.state,
                      });
                    }}
                    style={{ textDecoration: 'none' }}
                  >
                    <p className="model-sub-heading-search font-face-vz-eTX">{result.title}</p>
                  </Link>
                )}
                <p className="model-sub-heading-search font-face-vz-eTX">{result.subtitle}</p>
              </div>
              <div className="search-result-item-right">
                {(result.menus.views.length > 0 || result.menus.actions.length > 0) && (
                  <Dropdown drop="start">
                    <Dropdown.Toggle variant="success" className="dropdown-search-menu">
                      <MoreVertIcon fontSize="14" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-search-menu-items a">
                      <Dropdown.ItemText>Views</Dropdown.ItemText>
                      {result.menus.views.length > 0 &&
                        result.menus.views.map((menu) => {
                          let item = null;
                          if (menu.type === "state") {
                            item = (
                              <Dropdown.Item
                                key={menu.label}
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(isGlobalSearchModelVisible(false));
                                  navigate(menu.link, {
                                    state: menu.state,
                                  });
                                }}
                              >
                                {menu.label}
                              </Dropdown.Item>
                            );
                          }
                          if (menu.type === "url") {
                            item = (
                              <Dropdown.Item
                                as={Link}
                                key={menu.label}
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(isGlobalSearchModelVisible(false));
                                  navigate(menu.link);
                                }}
                                to={menu.link}
                              >
                                {menu.label}
                              </Dropdown.Item>
                            );
                          }

                          return item;
                        })}
                      <Dropdown.ItemText>Actions</Dropdown.ItemText>
                      {result.menus.actions.length > 0 &&
                        result.menus.actions.map((menu) => (
                          <Dropdown.Item
                            as={Link}
                            onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(isGlobalSearchModelVisible(false));
                                  navigate(menu.link);
                                }}
                            key={menu.label}
                            to={menu.link}
                          >
                            {menu.label}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>



  );
}

SearchResultCard.propTypes = {
  titleIcon: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
  totalResult: PropTypes.number.isRequired,
  viewMoreLink: PropTypes.shape({
    isState: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    state: PropTypes.object,
  }),
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      menus: PropTypes.shape({
        views: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string,
          })
        ),
        actions: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string,
          })
        ),
      }),
    })
  ),
};

export default SearchResultCard;
